export const TYPE_PRODUCT = [
  {
    name: 'Basico',
    value: 'BASIC'
  },
  {
    name: 'Ticket',
    value: 'TICKET'
  },
  {
    name: 'Digital',
    value: 'DIGITAL'
  }
]
